import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../utils';
import axios from 'axios';

const initialState = {
  loading: false,
  openVisit: {
    content: [],
  },
  submittedVisit: {
    content: [],
  },
  claimDetails: {
    timeline: [],
  },
};

export const fileClaim = createAsyncThunk(
  'newPreAuth/new',
  async ({ formData, openNotificationWithIcon, navigate }) => {
    console.log(...formData);
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${baseUrl}/claims`,
        data: formData,
        headers: {
          Accept: 'application/json',

          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(data);
      openNotificationWithIcon('success', data.message);
      navigate(`/pre-auths/${data?.result?.pre_authorisation_id}`);
      return data;
    } catch (error) {
      openNotificationWithIcon('error', error.message);
      console.log(error);
    }
  },
);

export const getSubmittedClaims = createAsyncThunk('getSubmittedClaims', async (pagination) => {
  let token = localStorage.getItem('x-auth-token');

  try {
    const response = await axios.get(
      `${baseUrl}/claims/list?sort=createdTimestamp,desc&page=${pagination?.page}&size=${pagination?.pageSize}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getSubmittedClaimsWithFilter = createAsyncThunk(
  'getSubmittedClaimsWithFilter',
  async ({ page, status }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const response = await axios.get(
        `${baseUrl}/claims/list?sort=createdTimestamp,desc&page=${page.page}&size=${10}${status !== '' && status !== null && status !== undefined ? `&status=${status}` : ''}`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const searchSubmittedClaims = createAsyncThunk(
  'searchSubmittedClaims',
  async ({ page, query }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const response = await axios.get(`${baseUrl}/provider/medical-claim/search?query=${query}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getClaimDetail = createAsyncThunk('getClaimDetail', async (id) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios.get(`${baseUrl}/claims/${id}/status/timeline`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getClaimVisits = createAsyncThunk('getClaimVisits', async (pagination) => {
  let token = localStorage.getItem('x-auth-token');
  try {
    const response = await axios.get(
      `${baseUrl}/provider/visit/list-for-claim?status=Close&sort=visitCreatedOn,desc&screen=Claim&page=${pagination?.page}&size=${pagination?.pageSize}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const searchClaims = createAsyncThunk('searchClaims', async (searchItem) => {
  let token = localStorage.getItem('x-auth-token');

  const searchObj = {};
  if (searchItem.search) {
    const key = Object.keys(searchItem.search);
    if (key[0] === 'Claim ID') {
      searchObj.claimId = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Member No.') {
      searchObj.memberNumber = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Patient Name') {
      searchObj.patientName = Object.values(searchItem.search)[0];
    }
  }
  let filterStr = '';
  if (searchItem.filters) {
    const keys = Object.keys(searchItem.filters);
    if (keys.indexOf('startDate') !== -1) {
      filterStr = filterStr + `&fromDate=${searchItem.filters['startDate']}`;
    }
    if (keys.indexOf('endDate') !== -1) {
      filterStr = filterStr + `&toDate=${searchItem.filters['endDate']}`;
    }
    if (keys.indexOf('doctor') !== -1) {
      filterStr = filterStr + `&attendingDoctorName=${searchItem.filters['doctor']}`;
    }
    if (keys.indexOf('status') !== -1) {
      filterStr = filterStr + `&status=${searchItem.filters['status']}`;
    }
  }

  try {
    const response = await axios.get(
      `${baseUrl}/provider/medical-claim/search?${Object.keys(searchObj).length > 0
        ? `${Object.keys(searchObj)[0]}=${Object.values(searchObj)[0]} `
        : ''
      }${filterStr}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const searchOpenClaims = createAsyncThunk('searchOpenClaims', async (searchItem) => {
  let token = localStorage.getItem('x-auth-token');
  const searchObj = {};
  if (searchItem.search) {
    const key = Object.keys(searchItem.search);
    if (key[0] === 'Visit ID') {
      searchObj.visitId = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Member No.') {
      searchObj.memberNumber = Object.values(searchItem.search)[0];
    } else if (key[0] === 'Patient Name') {
      searchObj.memberName = Object.values(searchItem.search)[0];
    }
  }
  let filterStr = '';
  if (searchItem.filters) {
    const keys = Object.keys(searchItem.filters);
    if (keys.indexOf('startDate') !== -1) {
      filterStr = filterStr + `&fromDate=${searchItem.filters['startDate']}`;
    }
    if (keys.indexOf('endDate') !== -1) {
      filterStr = filterStr + `&toDate=${searchItem.filters['endDate']}`;
    }
    if (keys.indexOf('doctor') !== -1) {
      filterStr = filterStr + `&attendingDoctorName=${searchItem.filters['doctor']}`;
    }
  }

  try {
    const response = await axios.get(
      `${baseUrl}/provider/visit/search-visit?status=Close&screen=Claim&${Object.keys(searchObj).length > 0
        ? `${Object.keys(searchObj)[0]}=${Object.values(searchObj)[0]} `
        : ''
      }${filterStr}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const claimSlice = createSlice({
  name: 'claim',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getClaimVisits.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getClaimVisits.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.openVisit = action.payload?.result;
      } else {
        state.openVisit = {
          content: [],
        };
      }
    });
    builder.addCase(getClaimVisits.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });
    builder.addCase(getSubmittedClaims.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubmittedClaims.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.submittedVisit = action.payload?.result;
      } else {
        state.submittedVisit = {
          content: [],
        };
      }
    });
    builder.addCase(getSubmittedClaims.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });
    builder.addCase(getSubmittedClaimsWithFilter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubmittedClaimsWithFilter.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.submittedVisit = action.payload?.result;
      } else {
        state.submittedVisit = {
          content: [],
        };
      }
    });
    builder.addCase(getSubmittedClaimsWithFilter.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });

    builder.addCase(searchSubmittedClaims.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchSubmittedClaims.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        console.log(action.payload?.result);
        state.submittedVisit.content = action.payload?.result;
        state.submittedVisit.property = null;
      } else {
        state.submittedVisit = {
          content: [],
        };
      }
    });
    builder.addCase(searchSubmittedClaims.rejected, (state) => {
      state.loading = false;
      state.submittedVisit = {
        content: [],
      };
    });

    builder.addCase(getClaimDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getClaimDetail.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.claimDetails = action.payload.result;
      } else {
        state.claimDetails = [];
      }
    });
    builder.addCase(getClaimDetail.rejected, (state) => {
      state.loading = false;
    });
    // search claims
    builder.addCase(searchClaims.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchClaims.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.submittedVisit = action.payload?.result;
      } else {
        state.submittedVisit = {
          content: [],
        };
      }
    });
    builder.addCase(searchClaims.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });

    // searchOpenClaims
    builder.addCase(searchOpenClaims.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchOpenClaims.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.openVisit = action.payload?.result;
      } else {
        state.openVisit = {
          content: [],
        };
      }
    });
    builder.addCase(searchOpenClaims.rejected, (state) => {
      state.loading = false;
      state.data = {
        content: [],
      };
    });
  },
});

export const { resetMember, addMemberError } = claimSlice.actions;

export default claimSlice.reducer;
